<template>

    <ReusableDropdown 
        class="dropdown-container"
        ref="dropdown"
        :class="[options.containerClass ? options.containerClass : '', !showMainBorder ? 'open' : '']"
        @open="dropdownOpen = true"
        @close="dropdownListOpen = false"
    >
        <template v-slot:trigger="{toggle, open}">
            <div class="dropdown-initial" @click="options.allowOpen ? toggle($event) : ''">
                <span v-if="options.singleIcon != true">{{
                    options.initial
                    ? options.selectAllChoice && isAllChecked()
                        ? toLocal(options.selectAllChoice)
                        : toLocal(options.initial)
                    : toLocal("generic.choose")
                }}</span>
                <span
                    :class="[{ reverse: dropdownOpen }, { initial: !dropdownOpen }]"
                    v-if="options.open != true && options.singleIcon != true"
                >
                    <slot name="arrow">
                        <ArrowDownSVG class="white" />
                    </slot>
                </span>
            </div>
        </template>
        <template v-slot:content="{toggle, open}">
            <div 
                class="dropdown-header-container"
                :class="{'opening': dropdownOpen}"
                v-if="options.type && options.type == 'groups-supervisor'"
            >
                <div class="dropdown-initial" @click="toggle">
                    <slot name="leftIcon">
                        
                    </slot>
                    <div class="dropdown-btn-icon" v-if="options.singleIcon" :class="{active: isDropdownOpen}">
                        <slot name="icon">
                            <FilterOnColumnsSVG />
                        </slot>
                    </div>
                    <span v-if="options.singleIcon != true">{{
                        options.initial
                        ? options.selectAllChoice && isAllChecked()
                            ? toLocal(options.selectAllChoice)
                            : toLocal(options.initial)
                        : toLocal("generic.choose")
                    }}</span>
                    <span
                        :class="[{ reverse: dropdownOpen }, { initial: !dropdownOpen }]"
                        v-if="options.open != true && options.singleIcon != true"
                    >
                        <slot name="arrow">
                        <ArrowDownSVG class="white" />
                        </slot>
                    </span>
                    <span class="closeBtn" v-if="options.closeBtn" @click="toggle"
                        ><CrossSVG
                    /></span>
                </div>
            </div>
                <div
                    class="dropdown-extended"
                    :class="{
                        left: options.left, 
                        dynamic: options.valueWidthType && options.valueWidthType =='dynamic',
                        top: true,
                        opening: dropdownListOpen
                    }"
                    ref="dropdownExtended"
                    v-if="open"
                    :style="[{
                    'max-width': options.customDDMaxWidth ? options.customDDMaxWidth : '',
                    'min-width': options.customDDMinWidth ? options.customDDMinWidth : '',
                    
                    }, options.dropdownStyle ? options.dropdownStyle : {}]"
                >
            
                    <div class="dropdown-users-toggle" v-if="options.type && options.type == 'groups-supervisor'">
                        
                        <div class="dropdown-users-toggle-switch">
                        <ToggleButton
                            :toggledState="options.showOnlyGroupUsers"
                            :height="32"
                            :width="64"
                            :innerHeight="28"
                            :innerWidth="28"
                            theme="search"
                            toggleDirection="right"
                            @changeState="$emit('showOnlyGroupUsers', $event)"
                            />
                        </div>
                        <span>{{toLocal('groups.show_only_group_users')}}</span>
                    </div>
                    <div class="search-box" v-if="options.searchBar">
                        <SearchSVG v-if="searchTerm == ''" />
                        <input
                            :class="{ gapLeft: searchTerm == '' }"
                            :placeholder="toLocal('dropdown.write')"
                            v-model="searchTerm"
                        />
                    </div>
                    <div
                        class="options-container"
                        :key="updateKey+'_tree'"
                        :style="{
                            maxHeight: options.customMaxHeight
                            ? options.customMaxHeight
                            : 'fit-content',
                        }"
                        v-if="options.type=='tree'"
                        >
                        <slot name="tree" >

                        </slot>
                    </div>
                    <div
                        class="options-container"
                        :key="updateKey"
                        :style="{
                            maxHeight: options.customMaxHeight
                            ? options.customMaxHeight
                            : 'fit-content',
                        }"
                        v-else
                    >
                        <div
                            class="dropdown-option all-option"
                            v-if="options.selectAllChoice && options.checkbox"
                            @click="selectAll()"
                        >
                            <div
                            class="checkbox"
                            v-if="options.checkbox"
                            :class="{ checked: isAllChecked() }"
                            >
                            <CheckmarkSVG class="checkmark" v-if="isAllChecked()" />
                            </div>
                            <span :class="{ bold: isAllChecked() }">{{
                            options.selectAllChoice
                            }}</span>
                        </div>
                        <div
                            class="options-wrapper added-users"
                            v-if="options.type && options.type == 'groups-supervisor'"
                            >
                            <div class="row-label"> {{toLocal('groups.assigned_users')}}</div>
                            <div
                                class="dropdown-option"
                                v-for="element in checkedItems"
                                :key="`el-${element[keyLabel]}`"
                                :class="[{ 
                                    selected: isChecked(element[keyLabel]), 
                                    'with-icon': element.icon 
                                    },element.class ? element.class : '',
                                    element.additional ? 'additional' : ''
                                ]"
                                @click="clickedOnElement(element[keyLabel])"
                            >
                                <div
                                    class="checkbox"
                                    v-if="options.checkbox"
                                    :class="{ checked: isChecked(element[keyLabel]) }"
                                >
                                <CheckmarkSVG
                                    class="checkmark"
                                    v-if="isChecked(element[keyLabel])"
                                />
                                </div>
                                <span :class="{ bold: isChecked(element[keyLabel]) }">{{
                                 toLocal(getDropdownValue(element))
                                }}</span>
                                <div class="right-icon" v-if="element.icon">
                                <slot :name="element.icon">
                                </slot>
                                </div>
                            </div>
                        </div>
                        <div class="options-wrapper">
                            <div class="row-label" v-if="options.type && options.type == 'groups-supervisor' ">
                                {{toLocal('users.unassigned_users') }}
                            </div>
                            <span v-if="searchTerm.length < 3 && !options.showOnlyGroupUsers && (options.type && options.type == 'groups-supervisor') " class="info-label">
                                {{toLocal('groups.search_users_by_name_label')}}
                            </span>
                            <div class="dropdown-option-wrapper" v-else>
                                <RecycleScroller
                                    :items="listItems"
                                    :item-size="34"
                                    :key-field="keyLabel"
                                    page-mode
                                    v-slot="{ item }"
                                >
                                    <div
                                        class="dropdown-option"
                                        :key="`el-${item[keyLabel]}`"
                                        :class="[{ 
                                                selected: isChecked(item[keyLabel]), 
                                                'with-icon': item.icon 
                                            },item.class ? item.class : '',
                                            item.additional ? 'additional' : ''
                                        ]"
                                        @click="clickedOnElement(item[keyLabel])"
                                    >
                                        <div
                                        class="checkbox"
                                        v-if="options.checkbox"
                                        :class="{ checked: isChecked(item[keyLabel]) }"
                                        >
                                        <CheckmarkSVG
                                            class="checkmark"
                                            v-if="isChecked(item[keyLabel])"
                                        />
                                        </div>
                                        <span :class="{ bold: isChecked(item[keyLabel]) }">{{
                                        toLocal(getDropdownValue(item))
                                        }}</span>
                                        <div class="right-icon" v-if="item.icon">
                                            <slot :name="item.icon">
                                            </slot>
                                        </div>
                                    </div>
                                </RecycleScroller>
                            </div>
                            <div class="hidden-option">
                            </div>
                        </div>
                    
                    </div>
                </div>
        </template>
    </ReusableDropdown>
</template>

<script>
import CheckmarkSVG from "@/assets/images/icons/checkmark_users.svg?inline";
import ArrowDownSVG from "@/assets/images/icons/arrow-down.svg?inline";
import CrossSVG from "@/assets/images/icons/users/cross.svg?inline";
import SearchSVG from "@/assets/images/icons/users/search.svg?inline";
import FilterOnColumnsSVG from "@/assets/images/icons/users/filter_on_columns.svg?inline";
import ToggleButton from "@/components/layout/emails/ToggleButton.vue";
import ReusableDropdown from "@/components/layout/elements/ReusableDropdown.vue";
export default {
    props:{
        list: {
            type: Array,
            default: null,
        },
        compareList: {
            type: Array,
            default: null,
        },
        compareChosen: {
            type: Object,
            default: null,
        },
        options: {
            type: Object,
            default: null,
        },
        keyLabel: {
            type: String,
            default: "id",
        },
        valueLabel: {
            type: String,
            default: "name",
        },
    },
    computed:{
        checkedItems(){
            return this.totalList.filter(el => this.isChecked(el[this.keyLabel]))
        },
        listItems(){
            return (this.options.type && this.options.type == 'groups-supervisor' ? this.totalList.filter(el => !this.isChecked(el[this.keyLabel])) : this.totalList)
        }
    },
    components:{
        CheckmarkSVG,
        ArrowDownSVG,
        CrossSVG,
        SearchSVG,
        FilterOnColumnsSVG,
        ToggleButton,
        ReusableDropdown
    },
    data(){
        return{
            isDropdownOpen: false,
            isDropdownListOpen: false,
            showMainBorder: true,
            searchTerm: "",
            totalList: [],
            updateKey: false,
            innerPopupOpen: false,
            dropdownOpen: false,
            dropdownListOpen: false,
        }
    },
    mounted() {
        setTimeout(() => {
            this.totalList = _.cloneDeep(this.list);
        },1000)
        if(this.options && this.options.openOnLoad){
            setTimeout(() => {
                this.$refs.dropdown.toggle()
            },100)
        }
    },
    watch: {
        searchTerm: {
            handler(newVal) {
                if (!this.options.searchLocally) {
                    if (newVal.length > 0) {
                        this.$emit("search", newVal);
                    } else {
                        this.$emit("search", null);
                    }
                } else {
                    this.searchList(newVal);
                }
            },
        },
        list(){
            if(!(this.options.type && this.options.type == 'groups-supervisor')){
                setTimeout(() => {
                this.totalList = _.cloneDeep(this.list);
                },1000)
            }
            else{
                setTimeout(() => {
                    this.searchList(this.searchTerm);
                },600)

            }
        },
        dropdownOpen() {
            if(this.dropdownOpen){
                setTimeout(() => {
                    this.dropdownListOpen = true;
                },300)
            }
            else{
                this.dropdownListOpen = false;
            }
            this.$emit("dropdownOpen", this.dropdownOpen);
        },
        dropdownListOpen() {
            if(!this.dropdownListOpen && this.dropdownOpen){
                setTimeout(() => {
                    this.dropdownOpen = false;
                },300)
            }
        },
    },
     methods: {
        searchList(val) {
            let delay_time = this.options && this.options.showOnlyGroupUsers ? 0 : 300
            if (val.length > 0) {
                if(delay_time){
                    setTimeout(() => {
                        this.totalList = this.list.filter((listItem) => {
                            if(this.valueLabel == 'fullName' && !listItem[this.valueLabel]){
                                return (listItem['name'] + ' ' + listItem['last_name']).toLowerCase().includes(val.toLowerCase())
                            }
                            return listItem[this.valueLabel] ? listItem[this.valueLabel].toLowerCase().includes(val.toLowerCase()) : false;
                        });
                    },delay_time)
                }
                else{
                    this.totalList = this.list.filter((listItem) => {
                        if(this.valueLabel == 'fullName' && !listItem[this.valueLabel]){
                                    return (listItem['name'] + ' ' + listItem['last_name']).toLowerCase().includes(val.toLowerCase())
                        }
                        return listItem[this.valueLabel] ? listItem[this.valueLabel].toLowerCase().includes(val.toLowerCase()) : false;
                    });
                }
            } else {
                if(delay_time){
                    setTimeout(() => {
                        this.totalList = _.cloneDeep(this.list);
                        
                    },delay_time)
                }
                else{
                    this.totalList = _.cloneDeep(this.list);
                
                }
            }
        },
        
        isAllChecked() {
            if (this.compareList) {
                let count = this.list.length;
                let selected = this.list.filter((lElem) => {
                    if (
                        this.compareList.find(
                        (el) => el[this.keyLabel] == lElem[this.keyLabel]
                        )
                    ) {
                        return lElem;
                    }
                }).length;
                if (count == selected) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        isChecked(id) {
            if (this.compareList) {
                return this.compareList.find((el) => el[this.keyLabel] == id);
            } else {
                return this.compareChosen[this.keyLabel] == id;
            }
        },
        clickedOnElement(id) {
            this.$emit("elClicked", id, this.options.attached);
            if (this.options.closeOnClick != false) {
                this.isDropdownListOpen = false;
                setTimeout(() => {
                this.isDropdownOpen = false;
                setTimeout(() => {
                    this.showMainBorder = true;
                }, 300);
                }, 300);
            }
            this.updateKey = !this.updateKey;
        },
        selectAll() {
            let isAll = this.isAllChecked();
            this.updateKey = !this.updateKey;
            this.$emit("elAll", isAll, this.options.attached);
            if (this.options.closeOnClick != false) {
                this.isDropdownListOpen = false;
                setTimeout(() => {
                    this.isDropdownOpen = false;
                    setTimeout(() => {
                        this.showMainBorder = true;
                    }, 300);
                }, 300);
            }
        },
        getDropdownValue(element) {
            return element[this.valueLabel];
        },
    },
    
}
</script>

<style lang="scss" scoped>
.dropdown-container {
  font-size: clamp(14px, 1.5vw, 16px);
  user-select: none;
  cursor: pointer;
  min-height: 32px;
//   position: relative;
  background-color: transparent;
  &:not(.no-padding-no-bg){
    padding: 4px 10px;
    background-color: #4d4d4d;
  
  }
  .whiteContrast{
    color: white;
    .dropdown-initial {
      color: white;
    }
  }
  .blackContrast{
    color: #333;
    .dropdown-initial {
      color: #333;
    }
  }
  .dropdown-initial {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    color: #333;
    span {
      max-width: 80%;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
    }
    .reverse {
      transition: 0.25s;
      transform: rotate(180deg);
    }
    .initial {
      transition: 0.25s;
      transform: rotate(0deg);
    }
    .white path {
      stroke: white;
    }
  }
  
}
.dropdown-content{
    font-size: clamp(14px, 1.5vw, 16px);
     min-height: 32px;
    .dropdown-initial {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        color: #333;
        span {
        max-width: 80%;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
        }
        .reverse {
        transition: 0.25s;
        transform: rotate(180deg);
        }
        .initial {
        transition: 0.25s;
        transform: rotate(0deg);
        }
        .white path {
        stroke: white;
        }
    }
    .search-box {
        padding: 10px 12px;
        display: flex;
        justify-self: center;
        align-items: center;
        position: relative;
        svg {
        position: absolute;
        left: 20px;
        }
        input {
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border: 1px solid #b2b2b2;
        padding: 4px 8px;
        &.gapLeft {
            padding-left: 28px;
        }
        }
    }
    .dropdown-extended {
        transform-origin: top;
        position: absolute;
        background: white;
        top: 100%;
        width: 100%;
        &:not(.left){
        right: 0;
        }
        .left{
        left: 0;
        }
        z-index: 10;
        color: #333;
        border-radius: 6px;
        background: #fff;
        transform: scaleY(0);
        transition: transform 0.3s ease;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.24);
        &.opening{
            transform: scaleY(1);
        }
        &.dynamic{
            width: initial;
            .dropdown-option {
                span{
                max-width: 100%;
                }
            }
            &.left{
                left: 0;
            }
        }
        .options-container {
            max-height: 200px;
            overflow-y: auto;
        }
        .dropdown-option {
            margin: 0px 8px;
            padding: 6px 0;
            display: flex;
            gap: 8px;
            align-items: center;
            cursor: pointer;
            &:hover {
                font-weight: 600;
            }
            &:nth-child(1 of .additional){
                position: relative;
                // border-top: 1px solid #7D7D7D;
                &::after{
                    content: '';
                    top: 0;
                    left: -8px;
                    width: calc(100% + 16px);
                    height: 1px;
                    position: absolute;
                    background-color: #7D7D7D;

                }
            
            }
            span {
                max-width: 80%;
                text-overflow: ellipsis;
                overflow-x: hidden;
                flex-wrap: nowrap;
                white-space: nowrap;
            }
            .checkbox {
                width: 16px;
                height: 16px;
                min-width: 16px;
                border-radius: 2px;
                border: 1px solid #4d4d4d;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                .checkmark {
                width: 100%;
                height: 100%;
                margin: 15%;
                }
                &.checked {
                background-color: var(--primary-color);
                }
            }
            .bold {
                font-weight: 600;
            }
            &.with-icon{
                justify-content: space-between;
            }
        
        }
        .all-option {
        border-bottom: 1px solid black;
        }
    }
}
.dropdown-users-toggle{
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.75rem 0.75rem 0.5rem;
}
.dropdown-header-container{
  position: absolute;
  top: 0;
  right: 0;
  // padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #B2B2B2;
  background: white;
  z-index: 11;
  min-height: 32px;
  width: calc(100% - 5rem);
  transition: width 0.3s ease;
  cursor: pointer;
  &.closing{
    z-index: 10;
  }
  &.opening{
    width: 100%;
    .reverse{

    }
  }
}
.dropdown-content{
  transition: border 0.3s ease;
  // z-index: 12;
  &:not(.no-padding-no-bg){
        padding: 0;
    }
  .dropdown-initial:not(.no-padding-no-bg){
    padding: 4px 10px;
  }
  .search-box{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
    border: 1px solid transparent;
    // z-index: 13;
    
    .options-container{
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
        padding: 0.5rem 0.75rem;
        .dropdown-option{
        margin: 0;
        }
        .row-label{
        text-align: left;
        font-weight: 600;
        }
    }
        .dropdown-extended .dropdown-option .checkbox.checked{
        background-color: transparent;
    }
    .dropdown-header-container{
        z-index: 13;
    }
  .options-container{
    width: 100%;
  }
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
/* Transition definitions */
.slide-fade-enter-active {
  transition: transform 0.25s ease;
}
.slide-fade-leave-active {
  transition: transform 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}

/* Enter start state */
.slide-fade-enter {
  transform: scaleY(0%);
}

/* Leave end state */
.slide-fade-leave-to {
  transform: scaleY(0%);
}
.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  z-index: 1;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  height: 32px;
  width: 5rem;
}
.slide-leave-to{
  
}

.closeBtn {
  svg path {
    fill: white;
  }
}
.create-new {
  border-top: 1px solid #b2b2b2;
  margin: 0px 10px;
  display: flex;
  align-items: center;
  padding: 6px 0;
  gap: 8px;
  &:hover {
    span {
      svg {
        box-sizing: content-box;
        border-radius: 50%;
        fill: var(--secondary-color);
        circle {
          fill: var(--secondary-color);
          stroke: #4d4d4d;
        }
      }
    }
  }
  span {
    display: flex;
    align-items: center;
  }
}

.options-wrapper{
  display: flex;
  flex-direction: column;
}
</style>
<style lang="scss">
.dropdown-btn-icon{
  display: flex;
  justify-content: center;
  align-items: center;
  &.active{
    background: #F4F4F4;
    border-radius: 50%;
    svg{
      path{
        fill: #4D4D4D;
      }
    }
  }
}
.options-container{
  .dropdown-option{
    .right-icon{
      svg{
        path{
          fill: #333;
        }
      }
    }
    &.danger{
      color:#D45454;
      .right-icon{
        svg{
          path{
            fill: #D45454;
          }
        }
      }
    }
  }
}
.info-label{
  color: #7D7D7D;
  font-size: 14px;
  text-align: left;
  margin-top: 5px;
}
</style>